export const FEE_SCHEDULE_TYPES = {
  TIERED_FEE_BY_INCREMENTAL_VALUE: 0,
  TIERED_FEE_BY_BREAKPOINT: 1,
  TOTAL_FEE: 2,
  MIXED: 3,
  FLAT_MAX_FEE: 4,
  HISTORIC_MAX_FEE: 5,
};

export const SOURCE = {
  ADMIN_CREATED: 0,
  NORMAL_USER_CREATED: 1,
  DATA_COLLECTION: 2,
};

export const USER_LEVEL = {
  SUPER_ADMIN: 0,
  GROUP_ADMIN: 1,
  NORMAL: 2,
};

export const TRADING_COMISSION_TYPES = {
  BUY_AND_SELL: 0,
  BUY: 1,
  SELL: 2,
  VAH: 3,
  AMOUNT: 0,
  PERCENT: 1,
};

export const FEE_CONFIG_TYPE = {
  EVERYTHING_OFF: 0,
  ONLY_FLAT_PERCENT: 1,
  ONLY_FEE_CHOICE: 2,
  EVERYTHING_ON: 3,
};

export const FEE_TYPES = {
  MAX_OR_FEE_SCHEDULE: 0,
  FLAT: 1,
  VARIES: 99,
};

export const FRONT_LOAD_TYPES = {
  STANDARD: 0,
  CUSTOM: 1,
  LOI: 4,
  VAH: 6,
};

export const FRONT_LOAD_AMOUNT_TYPES = {
  AMOUNT: 0,
  PERCENT: 1,
};

export const FRONT_LOAD_FEE_TYPE_OPTIONS = {
  STANDARD: `${FRONT_LOAD_TYPES.STANDARD}`,
  CUSTOM_AMOUNT: `${FRONT_LOAD_TYPES.CUSTOM}-${FRONT_LOAD_AMOUNT_TYPES.AMOUNT}`,
  CUSTOM_PERCENT: `${FRONT_LOAD_TYPES.CUSTOM}-${FRONT_LOAD_AMOUNT_TYPES.PERCENT}`,
  LOI: `${FRONT_LOAD_TYPES.LOI}`,
  VAH: `${FRONT_LOAD_TYPES.VAH}`,
};

export const PLAN_FEE_TYPES = {
  ESTIMATED_PERCENT: 0,
  BENCHMARK_PERCENT: 1,
  CUSTOM_PERCENT: 2,
};
